import { Component } from '@angular/core';

@Component({
  selector: 'ngx-only-header-layout',
  styleUrls: ['./only-header.layout.scss'],
  template: `
    <nb-layout class="no-column">
      <nb-layout-header fixed>
        <ngx-header></ngx-header>
      </nb-layout-header>

      <nb-layout-column>
        <ng-content select="router-outlet"></ng-content>
      </nb-layout-column>
    </nb-layout>
  `,
})
export class OnlyHeaderLayoutComponent { }
